import React from "react";
import MediaPreview from "./MediaPreview";

const formatBytes = (bytes) => {
  const value = Number(bytes);
  if (!value || Number.isNaN(value)) return "";
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(0)} KB`;
  return `${(value / (1024 * 1024)).toFixed(2)} MB`;
};

/**
 * Reusable media tile. Receives an already-normalized media object and emits
 * the selected object back up via onSelect.
 */
const MediaCard = ({ media, onSelect, highlighted = false }) => {
  if (!media) return null;

  const {
    mediaName,
    thumbnailUrl,
    previewUrl,
    mediaUrl,
    providerType,
    width,
    height,
    fileSize,
  } = media;

  const previewSrc = thumbnailUrl || previewUrl || mediaUrl;

  const dimensions =
    width && height ? `${width} × ${height}px` : "";
  const size = formatBytes(fileSize);

  return (
    <div className={`xc-ml-card ${highlighted ? "is-highlighted" : ""}`.trim()}>
      <div className="xc-ml-card__thumb">
        {providerType ? (
          <span className="xc-ml-card__badge">
            <i className="ri-image-line" aria-hidden="true" />
            {providerType}
          </span>
        ) : null}
        <MediaPreview src={previewSrc} alt={mediaName} />
      </div>

      <div className="xc-ml-card__body">
        <p className="xc-ml-card__name" title={mediaName}>
          {mediaName || "Untitled"}
        </p>

        <div className="xc-ml-card__meta">
          {dimensions ? (
            <span>
              <i className="ri-aspect-ratio-line" aria-hidden="true" />
              {dimensions}
            </span>
          ) : null}
          {size ? (
            <span>
              <i className="ri-hard-drive-2-line" aria-hidden="true" />
              {size}
            </span>
          ) : null}
        </div>

        <button
          type="button"
          className="xc-ml-card__select"
          onClick={() => onSelect?.(media)}
        >
          <i className="ri-check-line" aria-hidden="true" />
          Select
        </button>
      </div>
    </div>
  );
};

export default MediaCard;
